import { FilterMatchMode } from "primereact/api";

export class ItemCatalogo {
    model = {
        id: { value: null, export: false },
        nombre: {
            value: '', export: true, header: 'Nombre', required: 'Campo requerido', maxLength: 'Máximo 500 caracteres', minLength: 'Mínimo 4 caracteres',
            max: 500, min: 4, filterField: 'nombre', table: true, filter: true, sort: true, filterPlaceholder: 'Buscar por nombre.', matchMode: FilterMatchMode.CONTAINS
        },
        descripcion: {
            value: '', export: true, header: 'Descripción', required: 'Campo requerido', maxLength: 'Máximo 300 caracteres', minLength: 'Mínimo 4 caracteres',
            max: 300, min: 4, filterField: 'descripcion', table: false, filter: true, sort: true
        },
        origen: { header: 'Catálogo origen', value: null, required: 'Campo requerido', optionLabel: 'origen' },
        nemonico: {
            value: '', export: true, header: 'Sigla', required: 'Campo requerido', maxLength: 'Máximo 100 caracteres', minLength: 'Mínimo 4 caracteres',
            max: 100, min: 4, filterField: 'nemonico', table: false
        },
        valor: {
            value: '', export: true, header: 'Valor', required: 'Campo requerido', maxLength: 'Máximo 150 caracteres', minLength: 'Mínimo 4 caracteres',
            max: 150, min: 4, filterField: 'valor', table: false
        },
        estado: { header: 'Estado', value: { nombre: 'Activo', cat_id: 1 }, required: 'Campo requerido', optionLabel: 'nombre' },
        mostrar: { header: 'Mostrar', value: { nombre: 'SI', cat_id: 1 }, required: 'Campo requerido', optionLabel: 'nombre' },
        activado: { header: 'Activado', value: { nombre: 'SI', cat_id: 1 }, required: 'Campo requerido', optionLabel: 'nombre' },
        orden: { header: 'Orden', value: '', required: 'Campo requerido', minLength: 'Mínimo 1', max: 1000, min: 1 },
    }
    optionLabel = 'nombre'
}
